import type {Code, CodeList} from 'services/codelists/types';
import type {Metadata} from '../types';
import {getManifestationValue} from './getExpressionManifestationsValue';

type CodeLists = {
  productFormOverride?: CodeList;
  productForm?: CodeList;
  productFormDetails?: CodeList;
};

export const getExpressionManifestationsLocalCodelist = (
  state: {metadataEdit: {metadata?: Pick<Metadata, 'manifestations'>}},
  expressionId: string,
  codelists: CodeLists,
): CodeList => {
  const allManifestations =
    state.metadataEdit.metadata?.manifestations.filter(m => m.isbn) ?? [];

  const expressionManifestations = allManifestations.filter(
    m => m.expressionId === expressionId,
  );
  const otherManifestations = allManifestations.filter(
    m => m.expressionId !== expressionId,
  );
  const codes: Code[] = [
    ...expressionManifestations,
    ...otherManifestations,
  ].map(m => ({
    code: m.isbn!,
    value: getManifestationValue(m, codelists),
    deactivated: m.expressionId !== expressionId,
  }));

  return {
    id: 'expression_manifestation',
    language: 'nb',
    codes,
  };
};
